import React from 'react';

export const SettingsHeader: React.FC = () => {
    return (
        <>
            <div className="fixed top-0 left-0 right-0 z-40 bg-bg-header border-b border-border-default shadow-sm">
                <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between">
                    <div>
                        <h1 className="text-2xl font-black text-text-heading">Settings</h1>
                        <p className="text-xs text-text-muted mt-0.5">Account & preferences</p>
                    </div>
                </div>
            </div>
            <div className="h-[76px] w-full" />
        </>
    );
};
